// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pawmi: PokeData = {
  "id": 921,
  "name": "pawmi",
  "height": 3,
  "weight": 25,
  "base_experience": 48,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "scratch",
    "slam",
    "bite",
    "growl",
    "thunder-shock",
    "thunder-wave",
    "dig",
    "agility",
    "quick-attack",
    "spark",
    "charge",
    "discharge",
    "entrainment",
    "wild-charge",
    "nuzzle"
  ],
  "moves": [
    "scratch",
    "bite",
    "growl",
    "thunder-shock",
    "quick-attack",
    "wild-charge",
    "thunder",
    "zap-cannon",
    "thunder-punch",
    "electric-wrath",
    "electric-terrain",
    "thunderbolt",
    "thunder-fang"
  ],
  "evolution_chain": {
    "id": 484,
    "item": null,
    "species": [
      {
        "name": "pawmi",
        "order": 954,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pawmo",
        "order": 955,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 921,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "pawmot",
        "order": 956,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 922,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 33.75,
    "speed": 60,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
